
"use strict"; // jshint ignore:line

import {
	Object3D,
	Group,
	Vector3,
	LineBasicMaterial,
	Line,
	Geometry
} from '../../../src/js/three.module.js';
import { TextLabel }     from '../classes/TextLabel.js';
import { Oeuvre }        from '../classes/oeuvre.js';
import { Painting }      from '../classes/painting.js';
import { getIntersects } from '../GameTools.js';

export default function Helpers( opts, arrangement ){
	Group.call( this );

	this.opts = opts = opts || {};
	this.opts.oeuvreWallEdgeLines = this.opts.oeuvreWallEdgeLines || {};
	this.opts.oeuvreWallEdgeLines.iterations = 2;
	this.opts.oeuvreWallEdgeLines.gaps       = 6;
	this.opts.oeuvreWallEdgeLines.limit      = 5;

    this.opts.oeuvreHorizontalLines          = opts.oeuvreHorizontalLines || {};
    this.opts.oeuvreHorizontalLines.startCtr = !!opts.oeuvreHorizontalLines.startCtr;

    this.opts.oeuvreBottomLine_startBtm = this.opts.oeuvreBottomLine_startBtm==null?true:!!this.opts.oeuverBottomLine_startBtm;

	/******************/

	this.oeuvreBottomLines = {};

	this.oeuvreBetweenLines = {};

	this.oeuvreWallEdgeLines = {};

	this.byParent = {};

	this.targetface = new Line( new Geometry(), new LineBasicMaterial({ color: 0xffffff }));
	this.targetface.geometry.vertices.push(new Vector3( -10,  0, 0 ));
	this.targetface.geometry.vertices.push(new Vector3(   0, 10, 0 ));
	this.targetface.geometry.vertices.push(new Vector3(  10,  0, 0 ));
	this.targetface.geometry.vertices.push(this.targetface.geometry.vertices[0]);
	this.targetface.visible = false;
//	this.add( this.targetface );

	this.targetnormal = new Line( new Geometry(), new LineBasicMaterial({ color: 0xffffff }));
	this.targetnormal.frustumCulled = false;
	this.targetnormal.geometry.vertices.push(new Vector3( 0, 0, 0 ));
	this.targetnormal.geometry.vertices.push(new Vector3( 0, 0, 0 ));
	this.targetnormal.visible = false;
//	this.add( this.targetnormal );

	this.targetoeuvrenormal = new Line( new Geometry(), new LineBasicMaterial({ color: 0xffffff }));
	this.targetoeuvrenormal.frustumCulled = false;
	this.targetoeuvrenormal.geometry.vertices.push(new Vector3( 0, 0, 0 ));
	this.targetoeuvrenormal.geometry.vertices.push(new Vector3( 0, 1, 0 ));
//	this.add( this.targetoeuvrenormal );

}
Helpers.prototype = Object.create( Group.prototype );

Helpers.prototype.clear = function(){ };

Helpers.prototype.addByParent = function( uuid, helpers ){
	this.byParent[uuid] = this.byParent[uuid] || [];

	if( !Array.isArray( helpers )) helpers = [ helpers ];

	for( var idx in helpers ){
		this.byParent[ uuid ].push(helpers[ idx ]);
		this.add(helpers[ idx ]);
	}
};
Helpers.prototype.removeByParent = function( uuid ){
	if( !this.byParent[uuid] ) return;

	for( var idx in this.byParent[ uuid ]){
		this.remove(this.byParent[ uuid ][ idx ]);
	}
	delete this.byParent[uuid];
};

/*
██████  ███████ ███████ ██████  ███████ ███████ ██   ██  ██████  ███████ ██    ██ ██    ██ ██████  ███████ ██   ██ ███████ ██      ██████  ███████ ██████
██   ██ ██      ██      ██   ██ ██      ██      ██   ██ ██    ██ ██      ██    ██ ██    ██ ██   ██ ██      ██   ██ ██      ██      ██   ██ ██      ██   ██
██████  █████   █████   ██████  █████   ███████ ███████ ██    ██ █████   ██    ██ ██    ██ ██████  █████   ███████ █████   ██      ██████  █████   ██████
██   ██ ██      ██      ██   ██ ██           ██ ██   ██ ██    ██ ██      ██    ██  ██  ██  ██   ██ ██      ██   ██ ██      ██      ██      ██      ██   ██
██   ██ ███████ ██      ██   ██ ███████ ███████ ██   ██  ██████  ███████  ██████    ████   ██   ██ ███████ ██   ██ ███████ ███████ ██      ███████ ██   ██
*/
Helpers.prototype.refreshOeuvreHelper = function( oeuvre ){

	if (this.disabled) return;

	if( oeuvre === true ){
		oeuvre = this.$lastRefreshedOeuvre || null;
	}

	if( oeuvre instanceof Oeuvre ) this.$lastRefreshedOeuvre = oeuvre;
	else {
		oeuvre = this.$lastRefreshedOeuvre = null;
	}

	if (oeuvre) {
		if (oeuvre instanceof Painting) {
			this.refreshOeuvreBottomHelper( oeuvre );

			this.refreshOeuvreBetweenHelper( oeuvre );
		}

		// Piilotetaan kaikki (paitsi ko.) "alaviivat"
		for (let uid_a in this.oeuvreBottomLines)
			this.oeuvreBottomLines[uid_a].visible = (uid_a == oeuvre.uid);

		// Piilotetaan kaikki "väliviivat"
		for (let uid_a in this.oeuvreBetweenLines)
			for (let uid_b in this.oeuvreBetweenLines[uid_a])
				this.oeuvreBetweenLines[uid_a][uid_b].visible = false;

		// Piilotetaan kaikki "reuanviivat"
		for (let uid in this.oeuvreWallEdgeLines ) {
			if (uid != oeuvre.uid || !oeuvre.mesh.visible) {
				this.oeuvreWallEdgeLines[ uid ].left.visible = this.oeuvreWallEdgeLines[ uid ].right.visible = false;
			}
		}

		for (let uid in this.oeuvreBetweenLines[ oeuvre.uid ]) {
			this.oeuvreBetweenLines[oeuvre.uid][uid].visible = true;
			if (this.oeuvreBottomLines[uid]) this.oeuvreBottomLines[uid].visible = true;
		}

		// Jos seinä löytyy, asetetaan sinne näkeviä
		var wall = oeuvre.$wall;
		if (wall) {
			for (let uid_a in wall.oeuvres) {
				this.oeuvreBottomLines[ uid_a ] && (this.oeuvreBottomLines[ uid_a ].visible = true);
			}
		}

	} else {
		for (let uid_a in helpers.oeuvreBetweenLines)
			for (let uid_b in helpers.oeuvreBetweenLines[uid_a])
				helpers.oeuvreBetweenLines[uid_a][uid_b].visible = false;

		for (let uid in helpers.oeuvreBottomLines)
			helpers.oeuvreBottomLines[uid].visible = false;

		for (let uid in this.oeuvreWallEdgeLines) {
			this.oeuvreWallEdgeLines[ uid ].left.visible = this.oeuvreWallEdgeLines[ uid ].right.visible = false;
		}
	}
};
/*
██████  ███████ ███████ ██████  ███████ ███████ ██   ██  ██████  ███████ ██    ██ ██    ██ ██████  ███████ ██████   ██████  ████████ ████████  ██████  ███    ███ ██   ██ ███████ ██      ██████  ███████ ██████
██   ██ ██      ██      ██   ██ ██      ██      ██   ██ ██    ██ ██      ██    ██ ██    ██ ██   ██ ██      ██   ██ ██    ██    ██       ██    ██    ██ ████  ████ ██   ██ ██      ██      ██   ██ ██      ██   ██
██████  █████   █████   ██████  █████   ███████ ███████ ██    ██ █████   ██    ██ ██    ██ ██████  █████   ██████  ██    ██    ██       ██    ██    ██ ██ ████ ██ ███████ █████   ██      ██████  █████   ██████
██   ██ ██      ██      ██   ██ ██           ██ ██   ██ ██    ██ ██      ██    ██  ██  ██  ██   ██ ██      ██   ██ ██    ██    ██       ██    ██    ██ ██  ██  ██ ██   ██ ██      ██      ██      ██      ██   ██
██   ██ ███████ ██      ██   ██ ███████ ███████ ██   ██  ██████  ███████  ██████    ████   ██   ██ ███████ ██████   ██████     ██       ██     ██████  ██      ██ ██   ██ ███████ ███████ ██      ███████ ██   ██
*/
Helpers.prototype.refreshOeuvreBottomHelper = function( oeuvre ){

	if (this.disabled) return;

	var line = this.oeuvreBottomLines[oeuvre.uid];

	if( !line ){
		this.add( line = this.oeuvreBottomLines[oeuvre.uid] = oeuvre.helper_bottomLine = new Helpers.Line( ));
		line.refreshByOeuvre = this.refreshOeuvreBottomHelper.bind( this, oeuvre );
	}
	try {
		var bottoms = [], rels = oeuvre.relativesBetweenLines;
		for( var uid in rels ){
			if (rels[uid] instanceof Helpers.VerticalBetweenLine &&
			    oeuvre.mesh.position.y > (rels[uid].a == oeuvre ? rels[uid].b : rels[uid].a).mesh.position.y ){
				bottoms.push(uid);
			}
		}
		if( bottoms.length > 0 ) return line.setVisible( false );
	} catch(err){
		console.error("Failed to disable oeuvreBottomHelper", err)
	}

	if( !oeuvre.mesh.visible ) return line.setVisible( false );
	else line.setVisible( true );

	var frontalPoint = oeuvre.mesh.position.clone().add( new Vector3( 0, 0, oeuvre.d / 2 + Helpers.Line.z_offset ).applyEuler( oeuvre.mesh.rotation ));

	// Etäisyys lattiasta -apuviiva
	if( true ){
		var _btmVecH = 0;
		if( this.opts.oeuvreBottomLine_startBtm ){
			_btmVecH = oeuvre.h / 2;
			if( true && oeuvre.$frameable ){
				if( oeuvre.$frames.canvas ){
					let rr = oeuvre.$frames.canvas.rr || 0;
					if( typeof rr == "object" ) rr = rr.bottom;
					if( typeof rr == "number" ) _btmVecH += rr;
				}
				if( oeuvre.$frames.frame  ){
					let rr = oeuvre.$frames.frame.rr || 0;
					if( typeof rr == "object" ) rr = rr.bottom;
					if( typeof rr == "number" ) _btmVecH += rr;
				}
			}
		}

		var frontalBottomPoint = new Vector3( 0, -_btmVecH, 0 ).add(frontalPoint);
		var intersects         = getIntersects( frontalBottomPoint, new Vector3(0,-1,0)/*.applyEuler( oeuvre.mesh.rotation )*/ );
		var found = null;

		for( var i in intersects ){
			var intersect = intersects[i], current = intersect.object;
			while( current ){
				if( current.userData.type == "world" || current.userData.type == "floor" ) { found = intersect; break; }
				current = current.parent;
			}
			if( found ) break;
		}
		if( line.visible = !!found ) {
			line.setEnds( frontalBottomPoint, found.point );
			line.setRotation( oeuvre.mesh.rotation );
//			console.info("Moved oeuvre, height from ground "+found.distance+"m", oeuvre.mesh.rotation);
		}
	}
};
/*
██████  ███████ ███████ ██████  ███████ ███████ ██   ██  ██████  ███████ ██    ██ ██    ██ ██████  ███████ ██████  ███████ ████████ ██     ██ ███████ ███████ ███    ██ ██   ██ ███████ ██      ██████  ███████ ██████
██   ██ ██      ██      ██   ██ ██      ██      ██   ██ ██    ██ ██      ██    ██ ██    ██ ██   ██ ██      ██   ██ ██         ██    ██     ██ ██      ██      ████   ██ ██   ██ ██      ██      ██   ██ ██      ██   ██
██████  █████   █████   ██████  █████   ███████ ███████ ██    ██ █████   ██    ██ ██    ██ ██████  █████   ██████  █████      ██    ██  █  ██ █████   █████   ██ ██  ██ ███████ █████   ██      ██████  █████   ██████
██   ██ ██      ██      ██   ██ ██           ██ ██   ██ ██    ██ ██      ██    ██  ██  ██  ██   ██ ██      ██   ██ ██         ██    ██ ███ ██ ██      ██      ██  ██ ██ ██   ██ ██      ██      ██      ██      ██   ██
██   ██ ███████ ██      ██   ██ ███████ ███████ ██   ██  ██████  ███████  ██████    ████   ██   ██ ███████ ██████  ███████    ██     ███ ███  ███████ ███████ ██   ████ ██   ██ ███████ ███████ ██      ███████ ██   ██
*/
Helpers.prototype.refreshOeuvreBetweenHelper = function( oeuvre ){

	if (this.disabled) return;

	if( !oeuvre.relativesBetweenLines ){
		oeuvre.relativesBetweenLines = this.oeuvreBetweenLines[ oeuvre.uid ] = this.oeuvreBetweenLines[ oeuvre.uid ] || {};
	}

	var relatives = Object.keys( oeuvre.relativesBetweenLines );

	var MAX_DISTANCE  = 10;
	var MIN_COS_ANGLE = 0.9;
	var MAX_PLANE_COS = 0.1;

	var leftEdgeLine, rightEdgeLine;
	if( !this.oeuvreWallEdgeLines[ oeuvre.uid ]){
		this.oeuvreWallEdgeLines[ oeuvre.uid ] = {
			left:  leftEdgeLine  = new Helpers.Line(),
			right: rightEdgeLine = new Helpers.Line()
		};
		this.add( leftEdgeLine, rightEdgeLine );
	} else {
		leftEdgeLine  = this.oeuvreWallEdgeLines[ oeuvre.uid ].left;
		rightEdgeLine = this.oeuvreWallEdgeLines[ oeuvre.uid ].right;
	}


	var edge_n_len   = 0.05;
	var n_vec        = new Vector3( 0, 0, edge_n_len ).applyEuler( oeuvre.mesh.rotation );
	var minus_n_vec  = n_vec.clone().negate();
	var edge_itrs    = this.opts.oeuvreWallEdgeLines.iterations;
	var edge_gaps    = this.opts.oeuvreWallEdgeLines.gaps;
	var edge_limit   = this.opts.oeuvreWallEdgeLines.limit;


	var leftEdgeLine_dist, rightEdgeLine_dist;

	if( !this.opts.disableOeuvreWallEdgeLines ){

		var _btmVecW = 0;
		if( !this.opts.oeuvreHorizontalLines.startCtr ){
			_btmVecW = oeuvre.w / 2;
			if( oeuvre.$frameable ){
				if( oeuvre.$frames.canvas ){
					let rr = oeuvre.$frames.canvas.rr || 0;
					if( typeof rr == "object" ) rr = rr.left;
					if( typeof rr == "number" ) _btmVecW += rr;
				}
				if( oeuvre.$frames.frame  ){
					let rr = oeuvre.$frames.frame.rr || 0;
					if( typeof rr == "object" ) rr = rr.left;
					if( typeof rr == "number" ) _btmVecW += rr;
				}
			}
		}

		let nrm = minus_n_vec.clone().normalize().multiplyScalar( -Helpers.Line.z_offset );

		{
			let vec = (new Vector3( 1, 0, 0 )).applyEuler( oeuvre.mesh.rotation );
			let pos = oeuvre.mesh.position.clone().addScaledVector( vec, _btmVecW );

			if (leftEdgeLine_dist = edge_handler( pos.clone(), vec )) {
				leftEdgeLine.vertices[0].copy( pos ).add( nrm );
				leftEdgeLine.vertices[1].copy( pos.addScaledVector( vec, leftEdgeLine_dist )).add( nrm );
				leftEdgeLine.setEnds();
				leftEdgeLine.setRotation( oeuvre.mesh.rotation );
			}
		}

		{
			let vec = (new Vector3( -1, 0, 0 )).applyEuler( oeuvre.mesh.rotation );
			let pos = oeuvre.mesh.position.clone().addScaledVector( vec, _btmVecW );

			if (rightEdgeLine_dist = edge_handler( pos.clone(), vec )) {
				rightEdgeLine.vertices[0].copy( pos ).add( nrm );
				rightEdgeLine.vertices[1].copy( pos.addScaledVector( vec, rightEdgeLine_dist )).add( nrm );
				rightEdgeLine.setEnds();
				rightEdgeLine.setRotation( oeuvre.mesh.rotation );
			}
		}
	}

	/**************** ETSITÄÄN LÄHEISET ****************/

	/*
		1. Etsitään samalla seinällä olevat teokset
		1.1. Etsitään kaikki teokset
		1.2. Parsitaan liian kaukana olevat teokset
		1.3. Parsitaan eri asennossa olevat teokset
		1.4. Parsitaan eri pinnalla olevat teokset
		1.5. Parsitaan liian suuren korkeuseron takia hylättävät teokset
	*/


	var verticals = [];
	var horizontals = [];

	var other, oeuvres = {}, oeuvre_rotation_vec = new Vector3(0,0,1).applyEuler( oeuvre.mesh.rotation ), others_rotation_vec = {};
	for( var uid in window.oeuvres ){
		other = window.oeuvres[ uid ];
		if( other == oeuvre || !other.isSetted || !other.mesh.visible || !oeuvre.mesh.visible ) continue;


		// 1.2. Parsitaan liian kaukana olevat teokset
		if( MAX_DISTANCE < oeuvre.mesh.position.distanceTo( other.mesh.position )) continue;


		// 1.3. Parsitaan eri asennossa olevat teokset
		others_rotation_vec[other.uid] = others_rotation_vec[other.uid] || new Vector3(0,0,1).applyEuler( other.mesh.rotation );

		if( MIN_COS_ANGLE > oeuvre_rotation_vec.dot( others_rotation_vec[other.uid] )) continue;


		// 1.4. Parsitaan eri pinnalla olevat teokset
		var dife,other_pos_vec = other.mesh.position.clone().sub( oeuvre.mesh.position );
		if( MAX_PLANE_COS < (dife=Math.abs(other_pos_vec.normalize().dot( oeuvre_rotation_vec ) ) ))continue;


		// 1.5. "Ei kohdakkain" olevat teokset sekä jaotellaan horisontaali/vertikaali
		var dist = oeuvre.mesh.position.clone().setY(0).distanceTo( other.mesh.position.clone().setY(0) );

		// Jos etäisyys suurempaa kuin teosten leveysten puolikas, oltava horisontaalinen jos jotain
		if( dist > (oeuvre.w + other.w) / 2 ){
			if( Math.abs(oeuvre.mesh.position.y - other.mesh.position.y) <= ( oeuvre.h + other.h )/2 ) {
				horizontals.push( uid );
			} else continue;
		} else {
			if( Math.abs(oeuvre.mesh.position.y - other.mesh.position.y) >= ( oeuvre.h + other.h )/2 ) {
				// @TODO: Tarkista ettei välissä ole muita teoksia
				verticals.push( uid );
			} else continue;
		}

		// Hyväksytty
//		oeuvres[uid] = other;
	}

	// @TODO: Tarkista ettei välissä ole muita teoksia
	var on_btm_y = -Infinity, on_top_y = Infinity, on_top_uid, on_btm_uid;

	if( oeuvre && oeuvre.helper_bottomLine ){
		on_btm_y = oeuvre.helper_bottomLine.vertices[1].y;
	}

	for (let i in verticals) {
		let other = window.oeuvres[ verticals[i] ];
		if( other.mesh.position.y < oeuvre.mesh.position.y ){
			if( other.mesh.position.y > on_btm_y ){
				on_btm_y = other.mesh.position.y;
				on_btm_uid = verticals[i];
			}
		} else if( other.mesh.position.y > oeuvre.mesh.position.y ){
			if( other.mesh.position.y < on_top_y ){
				on_top_y = other.mesh.position.y;
				on_top_uid = verticals[i];
			}
		}
	}
	if( on_top_uid ) oeuvres[ on_top_uid ] = window.oeuvres[ on_top_uid ];
	if( on_btm_uid ) oeuvres[ on_btm_uid ] = window.oeuvres[ on_btm_uid ];




	var l_vec = (new Vector3(1,0,0)).applyEuler( oeuvre.mesh.rotation );
	var on_left_uid, on_right_uid;
	var on_left_len = leftEdgeLine_dist, on_right_len = rightEdgeLine_dist;

	for (let i in horizontals) {
		let other   = window.oeuvres[ horizontals[i] ];
		let vec     = other.mesh.position.clone().sub( oeuvre.mesh.position ).setY( 0 );
		let length  = vec.length();
		let on_left = l_vec.dot( vec ) > 0;

		if (on_left) {
			if( length < on_left_len ){
				on_left_len = length;
				on_left_uid = horizontals[i];
			}
		} else {
			if( length < on_right_len ){
				on_right_len = length;
				on_right_uid = horizontals[i];
			}
		}
	}

	if( on_left_uid  ) oeuvres[ on_left_uid  ] = window.oeuvres[ on_left_uid  ];
	if( on_right_uid ) oeuvres[ on_right_uid ] = window.oeuvres[ on_right_uid ];

	var curr_relatives = Object.keys( oeuvres );

	/**************** PÄIVITETÄÄN LÄHEISET ****************/

	// Poistettava jos löytyy vanhoista läheisista, muttei uusista
	var to_rm_uids = relatives.filter(function(uid){ return curr_relatives.indexOf(uid) == -1; });

	for (let i in to_rm_uids) {
		var line = oeuvre.relativesBetweenLines[ to_rm_uids[i] ];
		this.remove( line );

		delete this.oeuvreBetweenLines[ line.a.uid ][ line.b.uid ];
		delete this.oeuvreBetweenLines[ line.b.uid ][ line.a.uid ];

		delete oeuvre.relativesBetweenLines[ to_rm_uids[i] ];
	}

	// Lisättävä jos löytyy uusista läheisistä, muttei vanhoista
	var to_add_uids = curr_relatives.filter(function(uid){ return relatives.indexOf(uid) == -1; });

	for (let i in to_add_uids) {
		let uid = to_add_uids[i], other = oeuvres[ uid ], line;

		if (uid == on_left_uid) {
			line = new Helpers.HorizontalBetweenLine( oeuvre, oeuvres[ uid ] );
		} else if (uid == on_right_uid) {
			line = new Helpers.HorizontalBetweenLine( oeuvre, oeuvres[ uid ] );
		} else {
			line = new Helpers.VerticalBetweenLine( oeuvre, oeuvres[ uid ] );
		}
		line.z_offset = minus_n_vec.clone().multiplyScalar( -Helpers.Line.z_offset );

		this.add( line );

		oeuvre.relativesBetweenLines[ other.uid ] = line;

		this.oeuvreBetweenLines[ other.uid ] = this.oeuvreBetweenLines[other.uid] || {};
		this.oeuvreBetweenLines[ other.uid ][ oeuvre.uid ] = line;
	}

	//if( to_add_uids.length || to_rm_uids.length ){
	//	console.log(oeuvre.uid, oeuvre.relativesBetweenLines, to_add_uids, to_rm_uids);
	//}

	oeuvre.$lastLine = {};
	oeuvre.$lastLine.left  = on_left_uid  && oeuvre.relativesBetweenLines[ on_left_uid  ] || null;
	oeuvre.$lastLine.right = on_right_uid && oeuvre.relativesBetweenLines[ on_right_uid ] || null;
	oeuvre.$lastLine.top   = on_top_uid   && oeuvre.relativesBetweenLines[ on_top_uid   ] || null;
	oeuvre.$lastLine.btm   = on_btm_uid   && oeuvre.relativesBetweenLines[ on_btm_uid   ] || null;

	/****************** PÄIVITETÄÄN LÄHEISTEN VIIVAT ******************/

	for (let uid in this.oeuvreBetweenLines[ oeuvre.uid ]){
		this.oeuvreBetweenLines[ oeuvre.uid ][ uid ].refresh();
	}

	/***************** LUODAAN SEINÄN REUNOIHIN VIIVAT ****************/

	leftEdgeLine.visible = rightEdgeLine.visible = false;
	if (!this.opts.disableOeuvreWallEdgeLines) {
		if(  !on_left_uid && leftEdgeLine_dist)  oeuvre.$lastLine.left  =  leftEdgeLine;
		if( !on_right_uid && rightEdgeLine_dist) oeuvre.$lastLine.right = rightEdgeLine;
	}

	/*****************************************************************/

	for (var key in oeuvre.$lastLine) if (oeuvre.$lastLine[key]) oeuvre.$lastLine[key].visible = true;


	/*****************************************************************/

	function edge_handler( pos, vec ){
		try {
			var first   = getIntersects( pos.clone().add( n_vec ), vec ).filter(function(v){
				return !!v.face && (v.object.userData.type == "world" || v.object.userData.wall);
			})[0];

			var maxdist = Math.min( first ? first.distance : Infinity, edge_limit );

			var s_pos = pos.clone().add( n_vec );
			var dist = edge_iterate( 0, maxdist, edge_itrs, s_pos, vec );

			if( dist == maxdist ) dist = first && first.distance || false;

			if( dist ) return dist;

		} catch(err){
			console.error(err);
		}
		return false;
	}

	function edge_iterate( mindist, maxdist, iterations, pos, vec ){
		var found = false;

		for( var first, val, dplus = (maxdist - mindist) / edge_gaps, d = mindist, max = maxdist; d < max; d += dplus ){

			first = getIntersects( pos.clone().addScaledVector( vec, d ), minus_n_vec ).filter(function(v){
				return !!v.face && (v.object.userData.type == "world" || v.object.userData.wall);
			})[0];

			if( !first || first.distance > 2*edge_n_len ){
				maxdist = d;
				found   = true;
				break;
			} else {
				mindist = d;
			}
		}

		if( found && iterations > 0 ){
			return edge_iterate( mindist, maxdist, iterations-1, pos, vec );
		} else {
			return maxdist;
		}
	}
};
Helpers.prototype.clearOeuvreBetweenHelper = function( oeuvre ){
	if( oeuvre && this.oeuvreBetweenLines[oeuvre.uid] ){
		for( var i in this.oeuvreBetweenLines[oeuvre.uid] ){
			var line = this.oeuvreBetweenLines[oeuvre.uid][i];

			delete this.oeuvreBetweenLines[line.a.uid][i];
			delete this.oeuvreBetweenLines[line.b.uid][i];

			line.remove();
		}
	}
};
Helpers.prototype.hideHelpers = function() {
	for (let uid in this.oeuvreBottomLines) {
		this.oeuvreBottomLines[   uid ].setVisible( false );
	}

	for (let uid in this.oeuvreWallEdgeLines) {
		if (this.oeuvreWallEdgeLines[ uid ].left)  this.oeuvreWallEdgeLines[ uid  ].left.setVisible( false );
		if (this.oeuvreWallEdgeLines[ uid ].right) this.oeuvreWallEdgeLines[ uid ].right.setVisible( false );
	}

	for (var uid1 in this.oeuvreBetweenLines) {
		for (var uid2 in this.oeuvreBetweenLines[ uid1 ]) {
			this.oeuvreBetweenLines[ uid1 ][ uid2 ].setVisible( false );
		}
	}
};
/*
██   ██ ███████ ██      ██████  ███████ ██████  ███████    ██      ██ ███    ██ ███████
██   ██ ██      ██      ██   ██ ██      ██   ██ ██         ██      ██ ████   ██ ██
███████ █████   ██      ██████  █████   ██████  ███████    ██      ██ ██ ██  ██ █████
██   ██ ██      ██      ██      ██      ██   ██      ██    ██      ██ ██  ██ ██ ██
██   ██ ███████ ███████ ██      ███████ ██   ██ ███████ ██ ███████ ██ ██   ████ ███████
*/
Helpers.Line = function( ){
	Object3D.call( this );

	this.isHelperLine = true;

	this.label = new TextLabel("", { font: window.textfont, size: 0.25, height: 0.01 });

	this.line = new Line( new Geometry(), new LineBasicMaterial({ color: 0 }));
	this.line.frustumCulled = false;
	this.vertices = this.line.geometry.vertices;

	this.z_offset = new Vector3( );

	this.vertices.push(new Vector3( 0, 0, 0 ));
	this.vertices.push(new Vector3( 0, 1, 0 ));

	this.add( this.line, this.label );
};
Helpers.Line.z_offset = 0.05;

Helpers.Line.prototype = Object.create( Object3D.prototype );
Helpers.Line.prototype.setEnds = function( a, b, text ){

	if( a != null ) this.vertices[0].copy( a ).add( this.z_offset );
	if( b != null ) this.vertices[1].copy( b ).add( this.z_offset );

	// Asetetaan teksti linjan puoliväliin 
	this.label.position.set(
		(this.vertices[0].x + this.vertices[1].x) / 2,
		(this.vertices[0].y + this.vertices[1].y) / 2,
		(this.vertices[0].z + this.vertices[1].z) / 2 );

	this.length = this.vertices[0].distanceTo( this.vertices[1] );

	if( arguments.length != 3 ) text = Math.round( this.length*100 )/100 +"m";
	this.label.setText( text );

	this.line.geometry.verticesNeedUpdate = true;
};
Helpers.Line.prototype.setZOffset = function( z_offset ){
	this.z_offset.copy( z_offset );
};
Helpers.Line.prototype.setRotation = function( rotation ){
//	this.rotation.copy( rotation );
};
Helpers.Line.prototype.setVisible = function( visible ){
	return this.visible = visible;
};


Helpers.BetweenLine = function( a, b ){
	Helpers.Line.call(this);

	this.a = a;
	this.b = b;

	this.refresh();
};
Helpers.BetweenLine.prototype = Object.create( Helpers.Line.prototype );
Helpers.BetweenLine.prototype.refresh = function(){
	this.setEnds( this.a.mesh.position, this.b.mesh.position );
	this.setRotation( this.a.mesh.rotation );
};

Helpers.HorizontalBetweenLine = function( a, b ){
	Helpers.BetweenLine.call( this, a, b );
};
Helpers.HorizontalBetweenLine.prototype = Object.create( Helpers.BetweenLine.prototype );
Helpers.HorizontalBetweenLine.prototype.refresh = function(){
	var ctrY = (this.b.mesh.position.y - this.a.mesh.position.y)
	ctrY /= (this.a.h + this.b.h) / 2;
	ctrY *= this.a.h / 2;
	ctrY += this.a.mesh.position.y;

	var vec_a  = this.a.mesh.position.clone().setY(ctrY);
	var vec_b  = this.b.mesh.position.clone().setY(ctrY);

	var vec_d = vec_b.clone().sub( vec_a ).normalize();

	var w_a = this.a.w / 2, w_b = this.b.w / 2;

	if( true && this.a.$frameable ){
		if( this.a.$frames.canvas ){
			let rr = this.a.$frames.canvas.rr || 0;
			if( typeof rr == "object" ) rr = rr.left;
			if( rr && typeof rr == "number" ) w_a += rr;
		}
		if( this.a.$frames.frame  ){
			let rr = this.a.$frames.frame.rr || 0;
			if( typeof rr == "object" ) rr = rr.left;
			if( rr && typeof rr == "number" ) w_a += rr;
		}
	}
	if( true && this.b.$frameable ){
		if( this.b.$frames.canvas ){
			let rr = this.b.$frames.canvas.rr || 0;
			if( typeof rr == "object" ) rr = rr.left;
			if( rr && typeof rr == "number" ) w_b += rr;
		}
		if( this.b.$frames.frame  ){
			let rr = this.b.$frames.frame.rr || 0;
			if( typeof rr == "object" ) rr = rr.left;
			if( rr && typeof rr == "number" ) w_b += rr;
		}
	}

	vec_a.addScaledVector( vec_d,  w_a );
	vec_b.addScaledVector( vec_d, -w_b );

	this.setEnds( vec_a, vec_b );
	this.setRotation( this.a.mesh.rotation );
};
Helpers.VerticalBetweenLine = function( a, b ){
	this.vec_top = new Vector3();
	this.vec_btm = new Vector3();

	Helpers.BetweenLine.call( this, a, b );
};
Helpers.VerticalBetweenLine.prototype = Object.create( Helpers.BetweenLine.prototype );
Helpers.VerticalBetweenLine.prototype.refresh = function(){

	this.top = this.a.mesh.position.y > this.b.mesh.position.y ? this.a : this.b;
	this.btm = this.a.mesh.position.y > this.b.mesh.position.y ? this.b : this.a;

	var ctrP_top = this.top.mesh.position; //.clone().setY(0);
	var ctrP_btm = this.btm.mesh.position; //.clone().setY(0);

	var ctrP_c = new Vector3(( ctrP_top.x + ctrP_btm.x ) / 2, 0, ( ctrP_top.z + ctrP_btm.z ) / 2 );

//	var ctrP_v = ctrP_c.clone().sub( this.btm.mesh.position );
//	ctrP_c = this.btm.mesh.position.clone().addScaledVector( ctrP_v.length() / (( this.a.w + this.b.w ) / 2 ));

	this.vec_top.copy( ctrP_c ).setY( this.top.mesh.position.y - this.top.h/2 );
	this.vec_btm.copy( ctrP_c ).setY( this.btm.mesh.position.y + this.btm.h/2 );

	this.setEnds( this.vec_top, this.vec_btm );
	this.setRotation( this.a.mesh.rotation );
};

export function runKeyboardBasedPositionFineTuning( x = 1 ) {
	(spherical360SetupService.setupPlayerAttachedTo.position.x -= Math.sin(player.av)*((keyboardState.keyCodes[87]?.1:0)-(keyboardState.keyCodes[83]?.1:0))*x),
	(spherical360SetupService.setupPlayerAttachedTo.position.z -= Math.cos(player.av)*((keyboardState.keyCodes[87]?.1:0)-(keyboardState.keyCodes[83]?.1:0))*x),
	(spherical360SetupService.setupPlayerAttachedTo.position.x -= Math.sin(player.av+Math.PI/2)*((keyboardState.keyCodes[65]?.1:0)-(keyboardState.keyCodes[68]?.1:0))*x),
	(spherical360SetupService.setupPlayerAttachedTo.position.z -= Math.cos(player.av+Math.PI/2)*((keyboardState.keyCodes[65]?.1:0)-(keyboardState.keyCodes[68]?.1:0))*x),
	(spherical360SetupService.setupPlayerAttachedTo.position.y += (keyboardState.keyCodes[33]?x:0)/100),
	(spherical360SetupService.setupPlayerAttachedTo.position.y -= (keyboardState.keyCodes[34]?x:0)/100),
	(spherical360SetupService.attachedPlayerNeedsUpdate = gameService.inControlMode = gameService.renderNeeded = true)
}